// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5684c16002f6e16d8a76.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"df8e7b0d358e877dd9f8","180":"fe8096b321e82229a1d8","181":"bcf826187e1c0cccb16f"}[chunkId] + ".chunk.js";
};